import TagButton from './TagButton';

export default TagButton;
